import { create } from 'zustand';
import { Company } from '../types';

const DEFAULT_FORMAS_PAGAMENTO = [
  { id: 1, nome: 'Dinheiro', ativo: true, taxa: 0 },
  { id: 2, nome: 'Cartão de Crédito', ativo: true, taxa: 3.5 },
  { id: 3, nome: 'Cartão de Débito', ativo: true, taxa: 2.0 },
  { id: 4, nome: 'PIX', ativo: true, taxa: 0 },
  { id: 5, nome: 'Boleto', ativo: true, taxa: 2.5 },
  { id: 6, nome: 'Transferência', ativo: false, taxa: 0 },
];

interface CompanyState {
  company: Company | null;
  setCompany: (company: Company) => void;
  discountType: 'percentage' | 'value';
  setDiscountType: (type: 'percentage' | 'value') => void;
}

export const useCompanyStore = create<CompanyState>((set) => ({
  company: {
    id: '1',
    name: 'Clicsys Tecnologia',
    document: '12.345.678/0001-90',
    email: 'contato@clicsys.com',
    phone: '(11) 98765-4321',
    address: 'Av. Paulista, 1000 - São Paulo, SP',
    state: 'SP',
    logo: '/company_logo_placeholder.png',
    subscription: {
      plan: 'pro',
      status: 'active',
      expiresAt: '2025-12-31',
      features: ['Todos os módulos', 'Usuários ilimitados', 'Suporte prioritário'],
    },
  },
  setCompany: (company: Company) => {
    set((state) => {
      const settings = company.settings !== undefined
        ? (typeof company.settings === 'string' ? JSON.parse(company.settings) : company.settings)
        : state.company?.settings;
      return {
        company: {
          ...state.company,
          ...company,
          settings: {
            ...settings,
            formasPagamento: settings?.formasPagamento?.length
              ? settings.formasPagamento
              : DEFAULT_FORMAS_PAGAMENTO,
          },
          subscription: company.subscription || state.company?.subscription
        } as Company
      };
    });
  },
  discountType: 'percentage',
  setDiscountType: (type: 'percentage' | 'value') => {
    set({ discountType: type });
  },
}));

// Precificação padrão da empresa (companies.settings.precificacao). Os impostos da venda NÃO ficam
// aqui: vêm do motor fiscal pelo regime/regras tributárias (GET /products/margin). No Simples, a
// alíquota efetiva do DAS depende do faturamento e é informada pela empresa.
export interface Precificacao {
  margemPadrao: number;
  margemMinima: number;
  taxaCartao: number;
  outros: number;
  aliquotaDas: number | null;
}

export const PRECIFICACAO_PADRAO: Precificacao = {
  margemPadrao: 30,
  margemMinima: 15,
  taxaCartao: 3.5,
  outros: 0,
  aliquotaDas: null,
};

export const getPrecificacao = (settings: any): Precificacao => {
  const p = settings?.precificacao || {};
  const num = (v: any, d: number) => (v !== undefined && v !== null && v !== '' && !isNaN(Number(v)) ? Number(v) : d);
  return {
    margemPadrao: num(p.margemPadrao, PRECIFICACAO_PADRAO.margemPadrao),
    margemMinima: num(p.margemMinima, PRECIFICACAO_PADRAO.margemMinima),
    taxaCartao: num(p.taxaCartao, PRECIFICACAO_PADRAO.taxaCartao),
    outros: num(p.outros, PRECIFICACAO_PADRAO.outros),
    aliquotaDas: p.aliquotaDas !== undefined && p.aliquotaDas !== null && p.aliquotaDas !== '' && !isNaN(Number(p.aliquotaDas)) ? Number(p.aliquotaDas) : null,
  };
};

export const usePrecificacao = (): Precificacao => getPrecificacao(useCompanyStore((s) => s.company?.settings));
